import React, { Component } from 'react'
import i18n from '../i18n.json'

class EmotionsSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedEmotions: this.props.newLogo.userPrefs.selectedEmotions
    }
  }

  componentWillMount() {
    this.props.fetchEmotions()
  }

  onCheckboxClick(evt, id) {
    evt.preventDefault()
    let selected = parseInt(id, 10)
    let { selectedEmotions } = this.state
    let updated = selectedEmotions.splice(0)

    if (!updated.includes(selected)) {
      updated.push(selected)
    } else {
      updated = updated.filter(item => item !== selected)
    }
    this.setState({
      selectedEmotions: updated
    })
    this.props.updateSelectedEmotions({
      selectedEmotions: updated
    })
  }

  renderContent() {
    let { availableEmotions } = this.props.newLogo
    if (!availableEmotions) return
    let { selectedEmotions } = this.state
    if (!selectedEmotions) return

    let stylesJSX = availableEmotions.map((data) => {
      let selectionStatus = selectedEmotions.includes(data.uid) ? 'selected' : 'not-selected'
      let name
      if (this.props.newLogo.userPrefs.selectedLanguage === 'pt') {
        name = data.translations.pt_br.name
      } else {
        name = data.name
      }
      return (
        <li key={ "emotions-card" + data.name }>
          <a href={ "/select_emotion/" + data.uid } onClick={ (evt) => { this.onCheckboxClick(evt, data.uid) } } >
            <label className={ selectionStatus }> { name } </label>
          </a>
        </li>
      )
    })

    return stylesJSX
  }


  render() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div className="fullpage">
        <div className="flex-row">

           <div className="page-description">
              <h1>
                { i18n[selectedLanguage]['step-emotions-title-part1'] }<br />
                <span className="title-cta-red">
                { i18n[selectedLanguage]['step-emotions-title-cta'] }
                </span><br />
                { i18n[selectedLanguage]['step-emotions-title-part2'] }
              </h1>
              <p>
                { i18n[selectedLanguage]['step-emotions-description'] }
              </p>
           </div>

           <div className="page-content">
             <ul>
                { this.renderContent() }
             </ul>
           </div>

        </div>
      </div>
    )
  }
}

export default EmotionsSelector



// WEBPACK FOOTER //
// ./src/components/EmotionsSelector.js